// app.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';

// Componentes
import Login from './components/Login';
import Index from './components/Index';
import SplashScreen from './components/SplashScreen';
import PersonalTable from './components/PersonalTable';
import ProductosTable from './components/ProductosTable';
import AlmacenesTable from './components/AlmacenesTable';
import ProductosPorAlmacen from './components/ProductosPorAlmacen';
import ContratosTable from './components/ContratosTable';
import ProveedoresPage from './components/ProveedoresTable';
import UsuariosPage from './components/UsuariosTable';
import Auditoria from './components/Auditoria';
import GenerarPDF from './components/GenerarPDF';
import MovimientosPDF from './components/MovimientosPDF';
import ResguardoPDF from './components/ResguardoPDF';
import DiagnosticoPDF from './components/DiagnosticoPDF';
import PrivateRoute from './components/PrivateRoute';
import SoftwareTable from './components/SoftwareTable';
import Tags from './components/Tags';
import FacturaPage from './components/FacturaPage';
import ServiciosPage from './components/ServiciosPage';

// 🎨 Tema Material UI
const theme = createTheme({
  palette: {
    primary: { main: '#1976d2', light: '#1976d2', dark: '#004ba0' },
    secondary: { main: '#f50057' },
  },
});

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const handleSplashFinish = () => setShowSplash(false);

  // ==================================================
  // 🔐 AXIOS INTERCEPTORS (JWT CORRECTO)
  // ==================================================

  axios.interceptors.request.use(
    config => {
      const token = localStorage.getItem('access_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    error => Promise.reject(error)
  );

  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        localStorage.removeItem('access_token');
        window.location.href = '/';
      }
      return Promise.reject(error);
    }
  );

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />

      <Router>
        {showSplash ? (
          <SplashScreen onFinish={handleSplashFinish} />
        ) : (
          <Routes>
            {/* ===================== */}
            {/* 🌍 RUTA PÚBLICA */}
            {/* ===================== */}
            <Route path="/" element={<Login />} />

            {/* ===================== */}
            {/* 🔐 RUTAS PROTEGIDAS */}
            {/* ===================== */}
            <Route element={<PrivateRoute />}>
              <Route path="/index" element={<Index />} />
              <Route path="/personal" element={<PersonalTable />} />
              <Route path="/productos" element={<ProductosTable />} />
              <Route path="/almacenes" element={<AlmacenesTable />} />
              <Route path="/almacen/:almacenId" element={<ProductosPorAlmacen />} />
              <Route path="/contratos" element={<ContratosTable />} />
              <Route path="/proveedores" element={<ProveedoresPage />} />
              <Route path="/software" element={<SoftwareTable />} />
              <Route path="/tags" element={<Tags />} />
              <Route path="/facturas" element={<FacturaPage />} />
              <Route path="/servicios" element={<ServiciosPage />} />
              

              {/* PDFs */}
              <Route path="/generar-pdf" element={<GenerarPDF />} />
              <Route path="/movimientos-pdf" element={<MovimientosPDF />} />
              <Route path="/resguardo-pdf" element={<ResguardoPDF />} />
              <Route path="/diagnostico-pdf" element={<DiagnosticoPDF />} />
            </Route>

            {/* ===================== */}
            {/* 👑 SOLO ADMIN */}
            {/* ===================== */}
            <Route element={<PrivateRoute requireAdmin={true} />}>
              <Route path="/usuarios" element={<UsuariosPage />} />
              <Route path="/auditoria" element={<Auditoria />} />
            </Route>
          </Routes>
        )}
      </Router>
    </ThemeProvider>
  );
}

export default App;
